// NPM Imports
import React, { Component } from "react";
import Modal from "react-responsive-modal";
import { connect } from "react-redux";
import { Button, Toastr } from "@revvsales/components";

// Actions Imports
import {
  fetchAndUpdateDocMeta,
  resetDocToDraft,
} from "../../../../actions/DocumentActions";

// Internal Imports
import { AmplitudeUtils } from "../../../../utils";
import { EVENTS } from "../../../../constants";

// Destructuring
const { amplitudeLogEvent } = AmplitudeUtils;

class MoveDocStageToDraft extends Component {
  state = {
    showBtnLoader: false,
  };

  componentDidMount() {
    if (!this.props.showDialogBox) {
      this._resetDocumentToDraftStage();
    }
  }

  _resetDocumentToDraftStage = () => {
    this.setState({ showBtnLoader: true });
    const {
      documentID,
      documentNumber,
      documentStatus,
      documentTag,
      templateID,
    } = this.props;
    // Trigger Amplitude Event
    amplitudeLogEvent(EVENTS.EVENT_NAMES.EDIT_DOCUMENT_CLICKED, {
      documentID,
      status: documentStatus,
      tag: documentTag,
      templateID,
    });

    // Trigger API request to change the doc stage to draft
    this.props
      .resetDocToDraft(documentID)
      .then(() => {
        this.props
          .fetchAndUpdateDocMeta(documentNumber)
          .then(() => {
            Toastr.showToastr({
              type: "success",
              message: "Document moved to Drafts successfully!",
              timeout: 3000,
            });
            this._onClose();
          })
          .catch(error => {
            console.error(
              "MoveDocStageToDraft => _resetDocumentToDraftStage => this.props.fetchAndUpdateDocMeta: Error",
              error,
            );
            this._onClose();
          });
      })
      .catch(error => {
        console.error(
          "MoveDocStageToDraft => _resetDocumentToDraftStage => this.props.resetDocToDraft: Error",
          error,
        );
        Toastr.showToastr({
          type: "failure",
          message: "Oops! Something went wrong. Please try again later.",
          timeout: 3000,
        });
        this._onClose();
      });
  };

  _onClose = () => {
    this.props.onClose({ showSignerDetailsModal: false });
  };

  render() {
    const { showDialogBox } = this.props;
    const { showBtnLoader } = this.state;

    return (
      <Modal
        open={showDialogBox}
        onClose={this._onClose}
        center
        closeOnOverlayClick={false}>
        <div
          className="movedocstagetodraft-container"
          data-test="movedocstagetodraft-container">
          <div
            className="movedocstagetodraft-title"
            data-test="movedocstagetodraft-title">
            Sure you want to edit?
          </div>
          <div className="movedocstagetodraft-subtitle">
            This document has been sent for eSign or acceptance. Editing it will
            retract the previously sent requests and expire the shared link.
          </div>
        </div>
        <div className="movedocstagetodraft-footer">
          <Button
            className="btn-transparent movedocstagetodraft-cancle-btn"
            data-test="movedocstagetodraft-cancel-button"
            onClick={this._onClose}>
            Cancel
          </Button>
          <Button
            className="reject-document"
            data-test="movedocstagetodraft-proceed-button"
            isLoading={showBtnLoader}
            onClick={this._resetDocumentToDraftStage}>
            Edit document
          </Button>
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  const {
    document: {
      docNo: documentNumber,
      documentStatus: docStatus,
      documentTag: docTag,
      id: documentID,
      template_id: templateID,
    },
  } = state.DocumentStore;

  // Local Assignments
  const documentStatus = (docStatus && docStatus.name) || "";
  const documentTag = (docTag && docTag.name) || "";

  return {
    documentID,
    documentNumber,
    documentStatus,
    documentTag,
    templateID,
  };
};

const mapDispatchToProps = {
  fetchAndUpdateDocMeta,
  resetDocToDraft,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MoveDocStageToDraft);



// WEBPACK FOOTER //
// ./src/components/QuotationTopBarV3/Popups/MoveDocStageToDraft/index.js